import { render, staticRenderFns } from "./MailgunAdd.vue?vue&type=template&id=73566763&scoped=true"
import script from "./MailgunAdd.vue?vue&type=script&lang=js"
export * from "./MailgunAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73566763",
  null
  
)

export default component.exports